import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Axios from 'axios'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Vuelidate from 'vuelidate'
import i18n from "./i18n";
import axios from 'axios';
import lodash from 'lodash';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';

Vue.use(VueCustomTooltip);
Vue.use(Vuelidate);
Vue.use(Toast);
Vue.use(lodash);
Vue.use(VueViewer);

Vue.config.productionTip = true;
Vue.prototype.$http = Axios;

let url = '';

if(Vue.config.productionTip == false){
  url = 'https://dev.api.expansium.ru/admin/api/v1/';
}else{
  url = 'https://api.expansium.ru/admin/api/v1/';
}

axios.defaults.baseURL = url;
axios.defaults.headers.common['Authorization'] = store.state.token;

const token = localStorage.getItem('token');

if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token;
}

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
